import { IAction } from './action';

export class SetButtons implements IAction {
    constructor(public buttons: number) { }
}
